export default __webpack_public_path__ + "static/media/logo_mobil.47af1e74.png";